import React, { useState, useEffect } from "react";
import { Input, Spin, Table, notification } from "antd";
import { IconButton, PrimaryButton } from "../custom_components/customButton";
import { MdAddCircle } from "react-icons/md";
import { FaTags, FaMapMarkerAlt } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import "./locations.scss";
import {
    deleteLocation,
    fetchLocations,
    fetchDistricts,
} from "../stores/api_calls/locations";
import { RiDeleteBin2Fill, RiEdit2Fill } from "react-icons/ri";
import moment from "moment";
import Districts from "./Districts";
import LocationForm from "../forms/locations/LocationForm";
import { DistrictAddForm } from "../forms/locations/DistrictForm";
import CustomDeleteModal from "../custom_components/customDeleteModal";
import { colorScheme } from "../contants/variables";
import { error, success } from "../contants/snackbars";

const LocationIndex = (props) => {
    const [keywordSearch, setKeywordSearch] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [showModal, setShowModal] = useState({
        showLocationDelete: false,
        showDistrictDelete: false,
        showLocationForm: false,
        showDistrictForm: false,
        data: {},
        type: "Location",
    });
    const [isEdit, setIsEdit] = useState(false);
    const [tablePagination, setTablePagination] = useState({
        current: 1,
        pageSize: 10,
        total: "",
        defaultPageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} items`,
        pageSizeOptions: ["10", "20", "30"],
    });
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [districts, setDistricts] = useState({ data: [], isLoading: false });

    const columns = [
        { title: "Name", dataIndex: "name", key: "name" },
        {
            title: "No. of Districts",
            dataIndex: "number_of_districts", // Assuming API returns this
            key: "number_of_districts",
            render: (text, record) =>
                record.number_of_districts > 0 ? record.number_of_districts : "No Districts",
        },
        {
            title: "Date Created",
            dataIndex: "date_created",
            key: "date_created",
            render: (text, record) => (
                <span>{moment(record.date_created).format("LL")}</span>
            ),
        },
        { title: "Created By", dataIndex: "created_by", key: "created_by" },
        {
            title: "Date Updated",
            dataIndex: "date_updated",
            key: "date_updated",
            render: (text, record) => (
                <span>{moment(record.date_updated).format("LL")}</span>
            ),
        },
        { title: "Updated By", dataIndex: "updated_by", key: "updated_by" },

        {
            title: "Action",
            dataIndex: "actions",
            key: "actions",
            render: (text, record) => (
                <div className="actions-icons-container">
                    <IconButton
                        className="icon-button add"
                        tootTipTitle="Add District"
                        Icon={<MdAddCircle />}
                        onClick={() => handleAddDistrict(record)}
                    />
                    <IconButton
                        className="icon-button edit"
                        tootTipTitle="Edit Location"
                        Icon={<RiEdit2Fill />}
                        onClick={() => handleEditLocation(record)}
                    />
                    <IconButton
                        className="icon-button delete"
                        tootTipTitle="Delete Location"
                        Icon={<RiDeleteBin2Fill />}
                        onClick={() => handleDeleteLocation(record)}
                    />
                </div>
            ),
        },
    ];

    useEffect(() => {
        refetchLists();
    }, []);

    useEffect(() => {
        if (tablePagination.current || tablePagination.pageSize) {
            refetchLists();
        }
    }, [tablePagination.current, tablePagination.pageSize]);

    useEffect(() => {
        if (expandedRowKeys.length) {
            getDistricts();
        }
    }, [expandedRowKeys]);

    const onTableRowExpand = (expanded, record) => {
        const keys = [];
        if (expanded) {
            keys.push(record._id);
        }
        setExpandedRowKeys(keys);
        setIsExpanded(expanded);
    };

    const refetchLists = () => {
        const pagination = {
            page: tablePagination.current,
            limit: tablePagination.pageSize,
            keyword: keywordSearch,
        };

        fetchData(pagination);
    };

    const fetchData = (data) => {
        setIsLoading(true);
        const locations = fetchLocations(data);
        locations
            .then((res) => {
                if (res.data.success) {
                    setTableData(res.data.data);
                    setIsLoading(false);
                    setTablePagination({
                        ...tablePagination,
                        total: res.data.meta.pagination.total,
                    });
                }
            })
            .catch((e) => {
                console.log(e);
                setIsLoading(false);
            });
    };

    const getDistricts = () => {
        setDistricts({ ...districts, isLoading: true });
        const onGetDistricts = fetchDistricts(expandedRowKeys[0]);
        onGetDistricts
            .then((res) => {
                if (res.data.success) {
                    setDistricts({ ...districts, isLoading: false, data: res.data.data });
                }
            })
            .catch((e) => {
                console.log(e);
                setDistricts({ ...districts, isLoading: false });
            });
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setTablePagination(pagination);
    };

    const onEnter = (e) => {
        if (e.key === "Enter") {
            const pagination = {
                page: 1,
                limit: 10,
                keyword: keywordSearch,
            };
            fetchData(pagination);
        }
    };

    const handleAddLocation = () => {
        setIsEdit(false);
        setShowModal({ ...showModal, showLocationForm: true, type: "Location" });
    };
    const handleAddDistrict = (record) => {
        setIsEdit(false);
        setShowModal({
            ...showModal,
            showDistrictForm: true,
            type: "District",
            data: record,
        });
    };

    const handleEditLocation = (record) => {
        setIsEdit(true);
        setShowModal({
            ...showModal,
            showLocationForm: true,
            type: "Location",
            data: record,
        });
    };

    const handleDeleteLocation = (record) => {
        setShowModal({
            ...showModal,
            showLocationDelete: true,
            type: "Location",
            data: record,
        });
    };

    const onDeleteSubmit = () => {
        const location = deleteLocation(showModal.data._id);
        location
            .then((res) => {
                if (res.data.success) {
                    refetchLists();
                    success("Location Deleted");
                    setShowModal({ ...showModal, showLocationDelete: false, type: "Location" });
                }
            })
            .catch((e) => {
                error(
                    `Opps! ${e.response?.data?.server_response || "Error"} . Fetched Failed. Please try again later`,
                );
            });
    };

    return (
        <div className="brand-table-container">
            <div className="table-title-icon primary">
                <FaMapMarkerAlt />
            </div>
            <p className="table-title-text primary">Location Lists</p>

            <div className="search-container">
                <div className="add-button-container">
                    <PrimaryButton
                        Icon={<MdAddCircle />}
                        color={colorScheme.primary}
                        label="Add New Location"
                        onClick={() => handleAddLocation()}
                    />
                </div>

                <Input
                    style={{ width: 300 }}
                    size="large"
                    placeholder="Press Enter to Search Record"
                    prefix={<FiSearch />}
                    value={keywordSearch}
                    onChange={(e) => setKeywordSearch(e.target.value)}
                    onKeyPress={onEnter}
                />
            </div>

            <div className="scrollable-table-container">
                <Table
                    columns={columns}
                    rowKey={(record) => record._id}
                    expandedRowKeys={expandedRowKeys}
                    onExpand={onTableRowExpand}
                    expandable={{
                        expandedRowRender: (record) =>
                            isExpanded ? (
                                <div style={{ margin: 0 }}>
                                    <Districts
                                        itemId={record._id}
                                        districts={districts}
                                        getDistricts={getDistricts}
                                    />
                                </div>
                            ) : null,
                        // rowExpandable: (record) => record.number_of_districts !== 0,
                    }}
                    dataSource={tableData}
                    loading={{ indicator: <Spin size="large" />, spinning: isLoading }}
                    pagination={tablePagination}
                    onChange={handleTableChange}
                    bordered
                    sticky
                />
                ,
            </div>

            <LocationForm
                isEdit={isEdit}
                visible={showModal.showLocationForm}
                fetchData={fetchData}
                tablePagination={tablePagination}
                onCancel={() => {
                    setShowModal({ ...showModal, showLocationForm: false, data: {} });
                    setIsEdit(false);
                }}
                data={showModal.data}
            />
            <DistrictAddForm
                visible={showModal.showDistrictForm}
                getDistricts={getDistricts}
                refetchLists={refetchLists}
                onCancel={() => {
                    setShowModal({ ...showModal, showDistrictForm: false, data: {} });
                    setIsEdit(false);
                }}
                data={showModal.data}
            />
            <CustomDeleteModal
                title={`Delete ${showModal.type}`}
                visible={showModal.showLocationDelete}
                onSubmit={onDeleteSubmit}
                onCancel={() => {
                    setShowModal({ ...showModal, showLocationDelete: false, data: {} });
                    setIsEdit(false);
                }}
                data={{ itemName: `${showModal.data.name}`, type: showModal.type }}
            />
        </div>
    );
};

export default LocationIndex;
